module.exports = __webpack_public_path__ + "media/components/home/sign-up-free/img/sign-up-free-min-0fb9ff1e20305815a4355e4706b4e2bf.jpg";